import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNextdotjs} from "react-icons/si";
import matplotlib from "../../Assets/TechIcons/matplot.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import scikitlearn from "../../Assets/TechIcons/scikitlearn.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import Pandas from "../../Assets/TechIcons/Pandas.svg";
import NumPy from "../../Assets/TechIcons/NumPy.svg";
import Bootstrap from "../../Assets/TechIcons/Bootstrap.svg";
// import AWS from "../../Assets/TechIcons/AWS.svg";
// import Firebase from "../../Assets/TechIcons/Firebase.svg";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" />
        <div className="tech-icons-text">Python</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="Javascript" />
        <div className="tech-icons-text">Javascript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="Typescript" />
        <div className="tech-icons-text">Typescript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img
          src={matplotlib}
          alt="Matplotlib"
          className="tech-icon-matplot"
        />
        <div className="tech-icons-text">Matplotlib</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="Node.js" />
        <div className="tech-icons-text">Node.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="React.js" />
        <div className="tech-icons-text">React.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Mongo} alt="MongoDB" />
        <div className="tech-icons-text">MongoDB</div>
      </Col>


      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
        <div className="tech-icons-text">Next.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="Git" />
        <div className="tech-icons-text">Git</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={SQL} alt="PostgreSQL" />
        <div className="tech-icons-text">PostgreSQL</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Java} alt="Java" />
        <div className="tech-icons-text">Java</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={scikitlearn} alt="scikitlearn" />
        <div className="tech-icons-text">Sci-kit Learn</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="Tailwind CSS" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Pandas} alt="Pandas" />
        <div className="tech-icons-text">Pandas</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={NumPy} alt="NumPy" />
        <div className="tech-icons-text">NumPy</div>
      </Col>

            <Col xs={4} md={2} className="tech-icons">
        <img src={Bootstrap} alt="Bootstrap" />
        <div className="tech-icons-text">Bootstrap</div>
      </Col>

      {/* <Col xs={4} md={2} className="tech-icons">
        <img src={Firebase} alt="Firebase" />
        <div className="tech-icons-text">Firebase</div>
      </Col> */}

      {/* <Col xs={4} md={2} className="tech-icons">
        <img src={AWS} alt="AWS" />
        <div className="tech-icons-text">AWS</div>
      </Col> */}
    </Row>
  );
}

export default Techstack;
